import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "react-bootstrap/Carousel";
import { Image, Transformation } from "cloudinary-react";

const items = [
  {
    src: "/img/home/slider/slider-01",
    altText: "Underground Tours",
    header: "Underground Tours",
    caption: "Join us below the city to explore Cincinnati's hidden past.",
    learnmore: [
      { "ultimate-underground": "Ultimate Queen City Underground" },
      { hiddencaverns: "Hidden Caverns Tour" },
    ],
  },
  {
    src: "/img/home/slider/slider-02",
    altText: "1919 — The Year That Changed Baseball",
    header: "1919: The Year That Changed Baseball",
    caption: "Join us to learn about 1919 — the year that truly changed baseball forever.",
    learnmore: [{ "1919-tour": "Explore This Tour" }],
  },
  {
    src: "/img/home/slider/slider-03",
    altText: "Newport Gangster Tour",
    header: "Newport Gangster Tour",
    caption:
      "Walk the streets where the mob made millions, gamblers lost everything, and legends were born.",
    learnmore: [{ "newport-gangster-tour": "Explore This Tour" }],
  },
  {
    src: "/img/home/slider/slider-04",
    altText: "Haunted Tours",
    header: "Haunted Tours",
    caption:
      "Discover grisly murders, ghastly deaths, and disturbing tales buried within the Tri-State's storied past.",
    learnmore: [
      { "mt-healthy-is-haunted": "Mt. Healthy is Haunted" },
      { tours: "See All Tours" },
    ],
  },
];

const TopCarousel = () => {
  const slides = items.map((item, idx) => (
    <Carousel.Item key={idx}>
      {/* Desktop */}
      <Image
        className="d-none d-sm-block w-100"
        cloudName="american-legacy-tours"
        publicId={item.src}
        fetchpriority={idx === 0 ? "high" : "low"}
        fetch_format="auto"
        title={item.altText}
        style={{ display: "block" }}
      >
        <Transformation width="1800" height="700" crop="fill" />
      </Image>
      {/* Mobile */}
      <Image
        className="d-block d-sm-none w-100"
        cloudName="american-legacy-tours"
        publicId={item.src}
        fetchpriority={idx === 0 ? "high" : "low"}
        fetch_format="auto"
        title={item.altText}
        style={{ display: "block" }}
      >
        <Transformation width="800" height="800" crop="fill" />
      </Image>

      {/* Gradient overlay */}
      <div className="carousel-overlay" />

      <Carousel.Caption className="carousel-caption-custom">
        <div className="carousel-caption-inner">
          <h2 className="carousel-slide-title">{item.header}</h2>
          <p className="carousel-slide-subtitle">{item.caption}</p>
          <div className="carousel-slide-buttons">
            {item.learnmore.map((link) => {
              const [k, v] = Object.entries(link)[0];
              return (
                <a key={k} href={k} className="btn-brand carousel-slide-btn">
                  {v}
                </a>
              );
            })}
          </div>
        </div>
      </Carousel.Caption>
    </Carousel.Item>
  ));

  return (
    <Carousel
      fade={false}
      interval={5000}
      pause="hover"
    >
      {slides}
    </Carousel>
  );
};

export default TopCarousel;
